import Vue from 'vue';
import whatsapp_templateAPI from '../../api/whatsapp';

export const SET_WHATSAPP_TEMPLATE_UI_FLAG = 'SET_WHATSAPP_TEMPLATE_UI_FLAG';
export const ADD_TEMPLATES_TO_WHATSAPP = 'ADD_TEMPLATES_TO_WHATSAPP';
export const ADD_TEMPLATE_DATA = 'ADD_TEMPLATE_DATA';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  templatedata: {},
};

export const getters = {
  getTemplates($state) {
    return $state.records;
  },
  getInbox($state) {
    return $state.records;
  },
  createTemplate($state) {
    return $state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getTemplateFlags(_state) {
    return _state.templatedata;
  }
};

export const actions = {
  get: async ({ commit, rootGetters }, { accountId }) => {
    commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isFetching: true });
    try {
      const currentUser = rootGetters.getCurrentUser;
      const token = currentUser?.access_token;
      const records = await whatsapp_templateAPI.getInbox({ accountId, token });
      commit(ADD_TEMPLATES_TO_WHATSAPP, { records, accountId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },

  getTemp: async ({ commit }, { accountId }) => {
    commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: true });
    try {
      const records = await whatsapp_templateAPI.getTemplates({ accountId });
      commit(ADD_TEMPLATES_TO_WHATSAPP, { records, accountId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },

  create: async ({ commit, dispatch }, { accountId, data }) => {
    console.log("Account Id",accountId,data);
    commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: true });
    try {
      const response= await whatsapp_templateAPI.createTemplate({
        accountId,
        data,
      });
      console.log("Template create response:", response);
      if (response && response.status === 202 && response.data && response.data.status === 'queued') {
        // schedule a refresh to pull latest templates after background sync
        setTimeout(() => {
          dispatch('get', { accountId }).catch(() => {});
        }, 8000);
      }
      return response;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
  getInboxData: async ({ commit }, { accountId, InboxId, token }) => {
    try {
      console.log("my InboxID", InboxId);
      console.log("my AccountID", accountId);
      console.log("My token", token);
      const data = await whatsapp_templateAPI.getInbox({ accountId, InboxId, token });
      console.log("response", data);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
  fetchInboxChannelApiKey: async ({ commit }, { inboxId, access_token, accountId }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: true });
      const response = await whatsapp_templateAPI.fetchInboxchannelApi({ accountId, inboxId, access_token });
      return response;
    } catch (error) {
      console.error('Error fetching inbox channel API keys:', error);
      return null;
    }
    finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },

  // Fetch templates from local database with pagination support
  fetchTemplates: async ({ commit, rootGetters }, { inbox, accountId, keys, page = 1, perPage = 15, status = '', search = '' }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.fetchTemplates({
        inbox,
        accountId: resolvedAccountId,
        access_token,
        page,
        perPage,
        status,
        search,
      });
      return response;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },

  // Updated to use backend API instead of direct Graph API call
  ViewForm: async ({ commit, rootGetters }, { id, inboxId, accountId, keys }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isFetching: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.ViewTemplates({
        inboxid: id,
        inboxId,
        accountId: resolvedAccountId,
        access_token
      });
      console.log("Response", response);
      commit(ADD_TEMPLATE_DATA, response.data);
      return response.data;
    } catch (error) {
      console.error('Error Fetching the Data', error);
      throw error;
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },

  // Delete template via Graph API (deletes from WhatsApp)
  deleteTemplate: async ({ commit, rootGetters }, { name, inbox, accountId, keys }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.deleteTemplates({
        name,
        inbox,
        accountId: resolvedAccountId,
        access_token
      });
      console.log("Response", response);
      return response;
    } catch (err) {
      console.error('Error deleting template', err);
      throw err;
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },

  // Check if template is being used by macros/campaigns
  checkTemplateUsage: async ({ rootGetters }, { channelId, templateId, accountId }) => {
    try {
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.checkTemplateUsage({
        channelId,
        templateId,
        accountId: resolvedAccountId,
        access_token
      });
      return response;
    } catch (err) {
      console.error('Error checking template usage', err);
      throw err;
    }
  },

  // Soft delete template from CRM only (local database, does NOT delete from WhatsApp)
  softDeleteTemplate: async ({ commit, rootGetters }, { channelId, templateId, accountId }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.softDeleteTemplate({
        channelId,
        templateId,
        accountId: resolvedAccountId,
        access_token
      });
      console.log("Soft delete response", response);
      return response;
    } catch (err) {
      console.error('Error soft deleting template from CRM', err);
      throw err;
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },

  // Restore template from soft delete
  restoreTemplate: async ({ commit, rootGetters }, { channelId, templateId, accountId }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.restoreTemplate({
        channelId,
        templateId,
        accountId: resolvedAccountId,
        access_token
      });
      console.log("Restore response", response);
      return response;
    } catch (err) {
      console.error('Error restoring template', err);
      throw err;
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },

  // Updated to use backend API instead of direct Graph API call
  EditTemplate: async ({ commit, rootGetters }, { inboxId, templateId, dataToSend, accountId, keys }) => {
    try {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isUpdating: true });
      const currentUser = rootGetters.getCurrentUser;
      const access_token = currentUser?.access_token;
      // Get accountId from current account if not provided
      const resolvedAccountId = accountId || rootGetters.getCurrentAccountId;

      const response = await whatsapp_templateAPI.submitEditData({
        inboxId,
        templateId,
        dataToSend,
        accountId: resolvedAccountId,
        access_token
      });
      return response;
    } catch (err) {
      return { success: false, error: err };
    } finally {
      commit(SET_WHATSAPP_TEMPLATE_UI_FLAG, { isUpdating: false });
    }
  }
};

export const mutations = {
  [SET_WHATSAPP_TEMPLATE_UI_FLAG]($state, records) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...records,
    };
  },
  [ADD_TEMPLATES_TO_WHATSAPP]($state, { records, accountId }) {
    Vue.set($state.records, accountId, records);
  },
  [ADD_TEMPLATE_DATA](state, templateData) {
    state.templatedata = templateData; // Update the templatedata object with new data
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
